import { useState } from "react";
import { useSettings } from "../../../toolympus/api/useSettings"
import { useAction } from "../../../toolympus/api/useAction";
import { apiFetch } from "../../../toolympus/api/core";


export const useB24IntegrationSettings = () => {
  const settings = useSettings("/api/b24/settings", {});

  const [confroomsList, setConfroomsList] = useState<{ ID: string, CAL_TYPE: string, NAME: string }[] | null>(null);

  const getConfRooms = useAction(
    async () => {
      const rooms = await apiFetch("/api/b24/conf-rooms");
      setConfroomsList(rooms as any);
    }
  )

  return {
    ...settings,

    confroomsList,
    getConfRooms,
  }
}
